import axiosInstance from "./axiosInstance";

const getProjects = async (clientId: string) =>
  axiosInstance.get(`/v3/${clientId}/projects`);

export default getProjects;
